import { default as RootView } from "./root";
export * from "./root";
export default RootView;
